import React, { useState } from "react";
import { FaPlus, FaTrash, FaEdit, FaSave, FaTimes } from "react-icons/fa";

const SectionKelolaField = ({
  title,
  fields, // contoh: [{ key: "name", label: "Nama" }, { key: "code", label: "Kode", maxLength: 5 }]
  data = [],
  onAdd,
  onDelete,
  onEdit,
}) => {
  const [newItem, setNewItem] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [editItem, setEditItem] = useState({});

  const toTitleCase = (str) =>
    str
      .toLowerCase()
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

  // handle input tambah
  const handleChangeNew = (key, value) => {
    setNewItem((prev) => ({
      ...prev,
      [key]:
        key.toLowerCase().includes("name") || key.toLowerCase().includes("nama")
          ? toTitleCase(value)
          : key.toLowerCase().includes("code") ||
            key.toLowerCase().includes("kode")
          ? value.toUpperCase()
          : value,
    }));
  };

  const handleAdd = () => {
    if (
      fields.some((f) => !newItem[f.key] || !newItem[f.key].toString().trim())
    )
      return;

    onAdd({ ...newItem });
    setNewItem({});
  };

  // handle edit
  const startEdit = (item) => {
    setEditingId(item.id);
    setEditItem({ ...item });
  };

  const handleChangeEdit = (key, value) => {
    setEditItem((prev) => ({
      ...prev,
      [key]:
        key.toLowerCase().includes("name") || key.toLowerCase().includes("nama")
          ? toTitleCase(value)
          : key.toLowerCase().includes("code") ||
            key.toLowerCase().includes("kode")
          ? value.toUpperCase()
          : value,
    }));
  };

  const saveEdit = () => {
    if (
      fields.some((f) => !editItem[f.key] || !editItem[f.key].toString().trim())
    )
      return;

    onEdit({ ...editItem });
    setEditingId(null);
    setEditItem({});
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditItem({});
  };

  return (
    <div className="p-4 bg-white border rounded-lg shadow-sm">
      <h2 className="mb-4 text-lg font-semibold text-green-800">{title}</h2>

      {/* Input Tambah */}
      <div className="flex flex-wrap items-center gap-2 mb-4">
        {fields.map((field) => (
          <input
            key={field.key}
            type={field.type || "text"}
            placeholder={field.label}
            value={newItem[field.key] || ""}
            maxLength={field.maxLength || undefined}
            onChange={(e) => handleChangeNew(field.key, e.target.value)}
            className={`px-3 py-2 text-sm border border-green-300 rounded ${
              field.className ||
              (field.key.toLowerCase().includes("code") ||
              field.key.toLowerCase().includes("kode")
                ? "uppercase text-center w-20"
                : "flex-grow")
            }`}
          />
        ))}
        <button
          onClick={handleAdd}
          className="p-2 text-white bg-green-600 rounded hover:bg-green-700"
          title="Tambah"
        >
          <FaPlus size={12} />
        </button>
      </div>

      {/* Tabel Data */}
      {data.length === 0 ? (
        <p className="italic text-gray-400">Belum ada data</p>
      ) : (
        <table className="w-full text-sm border border-green-100">
          <thead className="bg-green-50">
            <tr>
              {fields.map((field) => (
                <th
                  key={field.key}
                  className="px-3 py-2 text-left border border-green-100"
                >
                  {field.label}
                </th>
              ))}
              <th className="px-3 py-2 text-center border border-green-100">
                Aksi
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.id} className="bg-gray-50">
                {fields.map((field) => (
                  <td
                    key={field.key}
                    className="px-3 py-2 border border-green-100"
                  >
                    {editingId === item.id ? (
                      <input
                        type={field.type || "text"}
                        value={editItem[field.key] || ""}
                        maxLength={field.maxLength || undefined}
                        onChange={(e) =>
                          handleChangeEdit(field.key, e.target.value)
                        }
                        className={`px-2 py-1 border border-green-300 rounded ${
                          field.className ||
                          (field.key.toLowerCase().includes("code") ||
                          field.key.toLowerCase().includes("kode")
                            ? "uppercase text-center"
                            : "w-full")
                        }`}
                      />
                    ) : (
                      <span className="font-medium">{item[field.key]}</span>
                    )}
                  </td>
                ))}
                <td className="px-3 py-2 text-center border border-green-100">
                  {editingId === item.id ? (
                    <div className="flex justify-center gap-2">
                      <button
                        onClick={saveEdit}
                        className="p-1 text-white bg-green-500 rounded hover:bg-green-600"
                        title="Simpan"
                      >
                        <FaSave size={12} />
                      </button>
                      <button
                        onClick={cancelEdit}
                        className="p-1 text-white bg-gray-400 rounded hover:bg-gray-500"
                        title="Batal"
                      >
                        <FaTimes size={12} />
                      </button>
                    </div>
                  ) : (
                    <div className="flex justify-center gap-2">
                      <button
                        onClick={() => startEdit(item)}
                        className="p-1 text-white bg-yellow-500 rounded hover:bg-yellow-600"
                        title="Edit"
                      >
                        <FaEdit size={12} />
                      </button>
                      <button
                        onClick={() => onDelete(item)}
                        className="p-1 text-white bg-red-500 rounded hover:bg-red-600"
                        title="Hapus"
                      >
                        <FaTrash size={12} />
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SectionKelolaField;
